import {colors} from '@mui/material';

const white = '#FFFFFF';
const black = '#000000';

export default {
   black,
   white,
   primary: {
      contrastText: white,
      dark: '#F57C00',
      main: '#FF9800',
      light: '#FFF3E0',
      disabled: colors.grey[500]
   },
   secondary: {
      contrastText: white,
      dark: '#4C80CC',
      main: '#699AE3',
      light: '#D6EBF5'
   },
   success: {
      contrastText: white,
      dark: '#22C55E',
      main: '#4ADE80',
      light: '#DCFCE7'
   },
   info: {
      contrastText: white,
      dark: '#368887',
      main: '#4AAB84',
      light: '#B2DFDB'
   },
   warning: {
      contrastText: white,
      dark: '#F57F17',
      main: '#FBC02D',
      light: '#FFFACC'
   },
   error: {
      contrastText: white,
      dark: '#EF4444',
      main: '#F76666',
      light: '#FFB6B6'
   },
   text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600],
      link: colors.blue[600]
   },
   background: {
      default: '#F8FAFD',
      paper: white
   },
   palette01: {
      contrastText: white,
      dark: colors.indigo[800],
      main: colors.indigo[600],
      light: colors.indigo[50]
   },
   icon: colors.blueGrey[600],
   divider: '#CECECE'
};
